(() => {
  const adtFilters = angular.module('adtFilters', []);

  adtFilters.$inject = ['CountriesList'];

  adtFilters.filter('abs', function () {
    return function (val) {
      return Math.abs(val);
    }
  });

  adtFilters.filter('isValidEmail', () => email => {
    if (!email || email.length < 5) {
      return false;
    }

    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  });

  /*
  Filter that highlights the passed values.
  Case insensitive.
  Must be used with ng-bind-html.
   */
  adtFilters.filter('highlight', $sce => (
    (haystack, needle) => {
      let output;

      if (angular.isUndefined(needle)) {
        output = haystack;
      } else if (haystack) {
        const query = needle.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
        output = haystack.replace(new RegExp(`(${query})`, 'ig'), ($1, match) => (
          `<strong class="highlight yellow">${match}</strong>`
        ));
      }

      return $sce.trustAsHtml(output);
    }
  ));

  adtFilters.filter('matchNames', function () {
      return function (arr, key) {
          return _.filter(arr, function (e) {
              var match = false,
                  reg = new RegExp(key, "i"),
                  ris = e.ris;
              if (e.name.match(reg)) return e.matched = true;
              else e.matched = false;
              _.each(ris, function (ri) {
                  ri.matched = ri.name.match(reg) ? match = true : false;
              })
              return match;
          })
      };
  });

  adtFilters.filter('sortedUnique', function () {
      return function (arr) {
          var sarr = _.sortBy(arr, function (item) {
              return item.name;
          })
          return _.unique(sarr, true, function (item) {
              return item.name.toLowerCase();
          })
      }
  });

  adtFilters.filter('unique', function () {
      return function (arr) {
          return _.unique(arr, true, function (item) {
              return item.name.toLowerCase();
          })
      }
  });

  adtFilters.filter('capitalize', function () {
      return function (str) {
          if (angular.isUndefined(str) || str.length == 0) return;
          var first = str.charAt(0);
          return /[a-zA-Z]/.test(first) ? first.toUpperCase() + str.slice(1) : str;
      }
  });

  adtFilters.filter('orderi', function () {
      return function (input) {
          if (angular.isUndefined(input)) return;
          return input.sort(function (a, b) {
              return (a.toLowerCase()).localeCompare(b.toLowerCase());
          });
      }
  });

  /*
   Formats a number according to the following convention:
   The US number 1,234,567.89 ->  1.234.567,89
   Accepts both numbers and strings. If strings are passed,
   it will try to parse the number out of it.
   */

  adtFilters.filter('customNumber', ($filter) => {
    const standardNumberFilter = $filter('number');
    return function (input, decimals) {
      if (typeof (input) == 'undefined') {
        return '';
      } else if (typeof (input) == 'number') {
        input = standardNumberFilter.apply(this, arguments) || 'NaN';
      } else if (typeof (input) == 'string') {
        arguments[0] = parseFloat(arguments[0]);
        input = standardNumberFilter.apply(this, arguments) || 'NaN';
      }

      return input.replace(/\./g, '|').replace(/,/g, '.').replace(/\|/g, ',');
    }
  });

  adtFilters.filter('customNumberNoTrailingZeroes', function ($filter) {
    var standardNumberFilter = $filter('number');
    return function (input, decimals) {
      if (typeof (input) == 'undefined') {
        return '';
      } else if (typeof (input) == 'number') {
        input = standardNumberFilter.apply(this, arguments) || 'NaN';
      } else if (typeof (input) == 'string') {
        arguments[0] = parseFloat(arguments[0]);
        input = standardNumberFilter.apply(this, arguments) || 'NaN';
      }

      //remove trailing zeroes
      input = input.replace(/(\.[0-9]*?)0+$/, '$1');
      // remove trailing dot if it no longer has trailing values
      input = input.replace(/\.$/, "");
      // use formatting standard
      return input.replace(/\./g, '|').replace(/,/g, '.').replace(/\|/g, ',');
    }
  });

  adtFilters.filter('emptyToEnd', function () {
    return function(array, key) {
      if (!angular.isArray(array)) return;

      const present = array.filter(item => item[key]);
      const empty = array.filter(item => !item[key]);

      return present.concat(empty);
    };
  });

  adtFilters.filter('emptyToEndAndSelectedFirst', function () {
    return function(array, key) {
      if (!angular.isArray(array)) return;

      const notSelected = array.filter(item => item[key] && !item['checked']);
      const selected = array.filter(item => item[key] && item['checked']);
      const empty = array.filter(item => !item[key]);

      return selected.concat(notSelected, empty);
    };
  });

  adtFilters.filter('formatCatName', ($filter) => (categories, catName, currency) => (
    _.map(categories, (cat, index) => {
      if (typeof cat !== 'object') return cat;

      let s = $filter('customNumber')(cat[0]);
      let e = $filter('customNumber')(cat[1]);
      let suffix = '';
      const prev = categories[index - 1];
      const next = categories[index + 1];

      if (catName == 'income' && currency !== null) {
        suffix = currency;
      }

      if (index === 0 && next) {
        return `< ${$filter('customNumber')(next[0])} ${suffix}`;
      } else if (index === categories.length - 1 && prev) {
        return `> ${$filter('customNumber')(prev[1])} ${suffix}`;
      }

      return `${s}-${e} ${suffix}`;
    })
  ));

  adtFilters.filter('relativeDate', () => {
    return function (date) {
      if (!date) return;

      if (!(date instanceof Date)) {
        date = new Date(date);
      }

      const now = new Date();
      const minute = 60;
      const hour = minute * 60;
      const day = hour * 24;
      const week = day * 7;
      const month = day * 30;
      const year = day * 365;
      const getDelta = () => Math.round((now - date) / 1000);

      let delta = getDelta();

      if (delta > day && delta < week) {
        date = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
        delta = getDelta();
      }

      switch (false) {
        case !(delta < 30): return 'just now';
        case !(delta < minute): return `${delta} seconds ago`;
        case !(delta < 2 * minute): return 'a minute ago';
        case !(delta < hour): return `${Math.floor(delta / minute)} minutes ago`;
        case Math.floor(delta / hour) !== 1: return 'an hour ago';
        case !(delta < day): return `${Math.floor(delta / hour)} hours ago`;
        case !(delta < day * 2): return 'yesterday';
        case !(delta < week): return `${Math.floor(delta / day)} days ago`;
        case Math.round(delta / week) !== 1: return 'a week ago';
        case !(delta < month): return `${Math.round(delta / week)} weeks ago`;
        case Math.floor(delta / month) !== 1: return 'a month ago';
        case !(delta < year): return `${Math.floor(delta / month)} months ago`;
        case Math.floor(delta / year) !== 1: return 'a year ago';
        default: return 'over a year ago';
      }
    };
  });

  // Mmm dd, yyyy
  adtFilters.filter('dateLong', () => strDate => {
    if (!strDate) return;

    if (!(strDate instanceof Date)) {
      strDate = new Date(strDate);
    }

    const monthNames = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]
    const date = new Date(strDate);
    const day = date.getDate();
    const index = date.getMonth();
    const year = date.getFullYear();
    return `${monthNames[index].substr(0, 3)} ${day}, ${year}`;
  });

  const getDateShort = date => {
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 1).toString().padStart(2, 0);
    const dd = date.getDate().toString().padStart(2, 0);
    return `${yyyy}-${mm}-${dd}`;
  }

  // yyyy-mm-dd
  adtFilters.filter('dateShort', () => date => {
    if (!date) return;

    if (!(date instanceof Date)) {
      date = new Date(date);
    }

    return getDateShort(new Date(date));
  });

  // yyyy-mm-dd HH:mm:ss
  adtFilters.filter('dateTimeShort', () => date => {
    if (!date) return;

    if (!(date instanceof Date)) {
      date = new Date(date);
    }

    const today = new Date(date);
    const HH = today.getHours().toString().padStart(2, 0);
    const mm = today.getMinutes().toString().padStart(2, 0);
    const ss = today.getSeconds().toString().padStart(2, 0);

    return `${getDateShort(date)} ${HH}:${mm}:${ss}`;
  });

  // yyyy-mm-dd
  adtFilters.filter('dateISO', () => date => {
    if (!date) return;

    if (!(date instanceof Date)) {
      date = new Date(date);
    }

    return new Date(date).toISOString().substring(0, 10);
  });

  // UTC timezone
  adtFilters.filter('timezone', () => date => {
    if (!date) return;
    const timestamp = date.replace('T', ',');
    return new Date(timestamp);
  });

  adtFilters.filter('range', function () {
      return function (val, range) {
          range = parseInt(range);
          for (var i = 0; i < range; i++)
              val.push(i);
          return val;
      };
  });

  adtFilters.filter('sumCount', function () {
      return function (uniformArray) {
          if (!uniformArray) return;
          var sum = 0;
          for (var i = 0; i < uniformArray.length; i++) {
              sum = sum + uniformArray[i].count;
          }
          return sum;
      };
  });

  adtFilters.filter('sumTotal', function () {
      return function (uniformArray) {
          var sum = 0;
          for (var i = 0; i < uniformArray.length; i++) {
              sum = sum + uniformArray[i].total;
          }
          ;
          return sum;
      };
  });

  adtFilters.filter('inArray', function($filter) {
      return function(list, arrayFilter, element) {
          if(arrayFilter){
              return $filter('filter')(list, function(listItem) {
                  return arrayFilter.indexOf(listItem[element]) != -1;
              });
          }
      };
  });

  adtFilters.filter('fullCountryName', (CountriesList) => {
    return function(countryCode) {
      if (!countryCode) return undefined;

      const country = CountriesList.find(country => country.code === countryCode);
      if (!country) {
        return '(unknown)';
      }

      return country.name;
    }
  });

  adtFilters.filter('fullLocationName', (CountriesList) => {
    return codeOrName => {
      if (!codeOrName) return undefined;

      const country = CountriesList.find(country => country.code === codeOrName);
      if (!country) {
        return codeOrName;
      }

      return country.name;
    }
  });
})();
